// The server decides an event's colour from what it is attached to. This is only
// the fallback for a payload that arrived without one, and it is deliberately a
// single value: a per-row palette made two identical events different colours.
export const NEUTRAL_EVENT_COLORS = {
  background_color: "#F5F5F5",
  text_color: "#000000",
  border_color: "#9E9E9E"
}

// Mirrors SEMANTIC_COLORS in ezbuild_back's apps/calendars/utils.py, so the
// filter legend names the same colour the server paints the events with. The
// border colour is too light to be legible as 12px text on its own background,
// so the legend's label uses `text_color`, a darker shade of the same hue.
export const SEMANTIC_EVENT_COLORS = {
  project: {
    background_color: "#EBF2FE",
    border_color: "#3B82F6",
    text_color: "#1D5FD0"
  },
  lead: {
    background_color: "#E8F8F5",
    border_color: "#45B39D",
    text_color: "#2A7060"
  },
  reminder: {
    background_color: "#fce9e9",
    border_color: "#ff6060",
    text_color: "#C21A1A"
  },
  event: NEUTRAL_EVENT_COLORS
}
